import $ from "jquery";
$(document).ready(function () {
    var $mouseX = 0, $mouseY = 0;
    var $xp = 0, $yp = 0;
    $(".hover-all").hover(function (e) {
        $(e.currentTarget).find(".pointer, .has-point, .button").addClass("hover");
    }, function (e) {
        $(e.currentTarget).find(".pointer, .has-point, .button").removeClass("hover");
    });
    $(".button-white").hover(function (e) {
        $(e.currentTarget).find(".pointer, .has-point, .button").addClass("is-white");
    }, function (e) {
        $(e.currentTarget).find(".pointer, .has-point, .button").removeClass("is-white");
    });
    $(".menu-white").hover(function (e) {
        $(".menu").addClass("is-white");
    }, function (e) {
        $(".menu").removeClass("is-white");
    });
    $(".hover-all").on("click", function (e) {
        e.preventDefault();
        if ($(e.currentTarget).hasClass("trigger-button"))
            $(e.currentTarget).find(".link").trigger("click");
        else
            document.location.href = $(e.currentTarget).find(".link").attr("href");
    });
    $(".pointer, a:not(.pointer), .has-point:not(.no-hover), .picture-wrapper, .highlight").hover(function () {
        $("#inside-cursor").addClass('animation-cursor');
        $("#inside-cursor-two").addClass('animation-cursor-two');
    }, function () {
        $("#inside-cursor").removeClass('animation-cursor');
        $("#inside-cursor-two").removeClass('animation-cursor-two');
    });
    $(".hover-all").hover(function () {
        $("#inside-cursor").addClass('animation-cursor-all');
        $("#inside-cursor-two").addClass('animation-cursor-two-all');
    }, function () {
        $("#inside-cursor").removeClass('animation-cursor-all');
        $("#inside-cursor-two").removeClass('animation-cursor-two-all');
    });
    $(".pointer-menu").mouseenter(function () {
        $("#inside-cursor-menu").addClass('animation-cursor-menu');
        $("#inside-cursor-two-menu").addClass('animation-cursor-two-menu');
    });
    $(".pointer-menu").mouseleave(function () {
        $("#inside-cursor-menu").removeClass('animation-cursor-menu');
        $("#inside-cursor-two-menu").removeClass('animation-cursor-two-menu');
    });
    $(".pointer-menu-line").mouseenter(function () {
        $("#inside-cursor-menu").addClass('animation-cursor-menu');
        $("#inside-cursor-two-menu").addClass('animation-cursor-two-menu');
        $("#line-menu").addClass('line-menu');
    });
    $(".pointer-menu-line").mouseleave(function () {
        $("#inside-cursor-menu").removeClass('animation-cursor-menu');
        $("#inside-cursor-two-menu").removeClass('animation-cursor-two-menu');
        $("#line-menu").removeClass('line-menu');
    });
    $(document).on('mousemove', function (e) {
        $mouseX = e.pageX - window.scrollX;
        $mouseY = e.pageY - window.scrollY;
        // if ($mouseY < 100) {
        //     $('#logo').addClass("view");
        // } else {
        //     $('#logo').removeClass("view");
        // }
        $('#personal-cursor-menu, #personal-cursor').css({
            left: $mouseX,
            top: $mouseY
        });
    });
});
